export class Constants {
    public static DefultPageSize = 10;
    public static SmallPageSize = 5;
}
